import UserTableRowViewModel from "./UserTableRowViewModel";

export default class UserTableViewModel {
    public count: number = 0;
    public rows: UserTableRowViewModel[] = [];
}